import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useDispatch } from 'react-redux';

import RetailPage from 'src/containers/Page/RetailPage';
import BreadCrumb from 'src/components/Retail/BreadCrumb/BreadCrumb';
import './RetailTest.scss';
import Button from 'src/components/Button/Button';

function RetailTest() {
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();

  const checkNameRoute = (route: string) => {
    switch (route){
      case 'tillConfig':
      case 'reprintLastTicket':
      case 'testPrinter':
      case 'tillStatus':
        return 'test-omr';
      default:
        return route;
    }
  };

  const handleClick = async (e) => {
    e.preventDefault();
    const { name } = e.target;
    const route = checkNameRoute(name);
    let query = '';

    if (name === 'tillConfig'){
      query='tab=-1&title=Till Config';
      await dispatch.peripherals.getReaderResponse({ command: 'TILLCONFIG' });
      dispatch.peripherals.reprintLastTicket();
    } else if (name === 'testPrinter'){
      await dispatch.peripherals.testPrinter();
      return ;
    } else if (name === 'loadLogo'){
      await dispatch.peripherals.loadLogo();
      return;
    } else if (name ==='reload'){
      history.go(0);
    } else if (name === 'tillStatus'){
      query='tab=-1&title=Till Status';
      await dispatch.peripherals.getReaderResponse({ command: 'TILLSTATUS' });
    }

    history.push(`${ route }?${ query }`);
  };


  return (
    <RetailPage>
      <BreadCrumb
        breadcrumbs={
          [
            { name: t('omr.home'), link: '/' },
            { name: t('omr.tests'), link: '/test-omr' }
          ]
        }
      />
      <div className="test">
        <div />
        <Button
          className="btn--primary test__button test__button--revert-color"
          size="medium"
          name="testPrinter"
          onClick={ handleClick }
          text={ t('home.testPrinter') }
        />
        <Button
          className="btn--primary test__button test__button--revert-color"
          size="medium"
          name="test-omr"
          onClick={ handleClick }
          text={ t('home.testOMR') }
        />
        <Button
          className="btn--primary test__button test__button--revert-color"
          size="medium"
          name="tillConfig"
          onClick={ handleClick }
          text={ t('home.showTillConfig') }
        />
        <div />
        <div />
        <Button
          className="btn--primary test__button test__button--revert-color"
          size="medium"
          name="reload"
          onClick={ handleClick }
          text={ t('home.refresh') }
        />
        <Button
          className="btn--primary test__button test__button--revert-color"
          size="medium"
          name="loadLogo"
          onClick={ handleClick }
          text={ t('home.loadLogo') }
        />
        <Button
          className="btn--primary test__button test__button--revert-color"
          size="medium"
          name="tillStatus"
          onClick={ handleClick }
          text={ t('home.tillStatus') }
        />
        <div />
        <div />
      </div>
    </RetailPage>
  );
}

export default RetailTest;
